import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useIsMobile from "../Hooks/useIsMobile";

const ExpandBox = ({ title, isOpen, toggle,marginTop, children }) => {
  const isMobile = useIsMobile();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        marginBottom: 2,
        marginTop:marginTop,
        border: "1px solid",
        borderColor: isOpen
          ? isDarkMode
            ? "primary.light"
            : "primary.main"
          : isDarkMode
          ? "grey.700"
          : "grey.300",
        padding: isMobile ? 1 : 2,
        borderRadius: 2,
        boxShadow: isOpen
          ? isDarkMode
            ? "0px 4px 12px rgba(255, 255, 255, 0.1)"
            : "0px 4px 12px rgba(0, 0, 0, 0.1)"
          : "none",
        transition: "box-shadow 300ms ease, border-color 300ms ease",
        backgroundColor: isDarkMode ? "grey.900" : "white",
      }}
    >
      <Typography
        variant={isMobile ? "subtitle1" : "h6"}
        onClick={toggle}
        sx={{
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: isMobile ? 1 : 1.5,
          backgroundColor: isOpen
            ? isDarkMode
              ? "grey.800"
              : "grey.100"
            : isDarkMode
            ? "grey.850"
            : "#fafafa",
          borderRadius: 2,
          transition: "background-color 300ms ease",
          fontWeight: "bold",
          color: isDarkMode ? "grey.200" : "text.primary",
        }}
      >
        {title}
        {isOpen ? (
          <ExpandLess
            sx={{
              color: isDarkMode ? "primary.light" : "primary.main",
              fontSize: isMobile ? 20 : 28,
            }}
          />
        ) : (
          <ExpandMore
            sx={{
              color: isDarkMode ? "grey.500" : "grey.500",
              fontSize: isMobile ? 20 : 28,
            }}
          />
        )}
      </Typography>

      <Collapse
        in={isOpen}
        timeout="auto"
        unmountOnExit
        sx={{
          marginTop: 2,
          transition: "height 300ms ease-in-out, opacity 300ms ease-in-out",
        }}
      >
        <Divider
          sx={{
            marginBottom: 2,
            borderColor: isDarkMode ? "grey.700" : "grey.200",
          }}
        />
        <Box
          sx={{
            paddingX: isMobile ? 1 : 2,
            fontSize: isMobile ? "0.875rem" : "1rem",
            lineHeight: isMobile ? 1.4 : 1.6,
            color: isDarkMode ? "grey.300" : "text.secondary",
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ExpandBox;
